export const LoaderModalStyles = {
    loaderModal: {
        wrapper: "flex flex-col items-center justify-center py-12 px-6 text-center min-h-[300px]",
        wrapperXl: "flex flex-col items-center justify-center text-center px-4 sm:px-6 py-6 sm:py-8 animate-fadeIn h-full",
        wrapper4xl: "flex flex-col items-center justify-center py-12 px-6 text-center min-h-[300px]",
        wrapper6xl: "flex flex-col items-center justify-center py-12 px-6 text-center min-h-[300px]",
        spinnerContainer: "mb-6 transform scale-75",
        title: "text-lg font-semibold text-gray-900",
        subtitle: "text-gray-600 text-sm mt-2",
        message: "font-montserrat font-medium text-center text-[--iw-color-header] w-full sm:w-auto mt-2 break-words px-2 max-w-[320px]"
    }
};